import PropTypes from 'prop-types'
import React from 'react'
import Button from '../../../../common/components/Button'
import { LabelSet } from '../../../../common/components/Label'

const modes = ['view', 'discuss', 'edit']

export const ModeSwitcher = ({
  allowed,
  setMode,
  currentMode,
  t
}) => {
  // only render if user can switch mode
  if (!allowed['edit'] && !allowed['discuss']) return null

  return (
    <>
      <LabelSet>
        {modes.map(
          mode =>
            allowed[mode] && (
              <Button
                active={currentMode === mode}
                onClick={() => setMode(mode)}
                key={mode}
              >
                {t(`mode.${mode}`)}
              </Button>
            )
        )}
      </LabelSet>
    </>
  )
}

ModeSwitcher.propTypes = {
  setMode: PropTypes.func.isRequired,
  currentMode: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
}

export default ModeSwitcher
